import React, {useState, useEffect} from "react";

export default function TrendBack({
  lightContrast,
  darkContrast,
  stitching,
  patchColor,
  azomo,
  printStyle,
  getDataFromChild,
  preview,
}) {
  function adjust(color, amount) {
    return (
      "#" +
      color
        .replace(/^#/, "")
        .replace(/../g, (color) =>
          (
            "0" + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)
          ).substr(-2)
        )
    );
  }

  const [darkenColor, setDarkenColor] = useState(darkContrast);

  const [lightContrastActive, setLightContrastActive] = useState(false);
  const [darkContrastActive, setDarkContrastActive] = useState(false);
  const [stitchingActive, setStitchingActive] = useState(false);
  const [patchActive, setPatchActive] = useState(false);
  const [azomoActive, setAzomoActive] = useState(false);

  const handleClick = (tabId) => {
    if (!preview) {
      getDataFromChild(tabId);
    }
  };

  useEffect(() => {
    setDarkenColor(adjust(lightContrast, -150));
  }, lightContrast);

  return (
    <svg
      className={printStyle}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 500 500"
      enableBackground="new 0 0 500 500"
    >
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M227.96,265.044c-0.443-4.767-1.607-9.572-2.727-14.225l-0.154-0.623c-1.131-4.684-2.465-9.495-4.073-14.705
 c-1.519-4.926-3.197-9.938-5.138-15.323c-1.798-4.991-3.805-10.244-5.964-15.612c-2.023-5.019-4.226-10.272-6.549-15.602
 c-2.159-4.947-4.478-10.092-6.888-15.285c-2.22-4.777-4.57-9.703-6.986-14.65c-2.203-4.499-4.505-9.108-6.845-13.705
 c-2.099-4.117-4.269-8.304-6.456-12.448c-1.907-3.619-3.87-7.281-5.827-10.884c-1.651-3.05-3.318-6.079-4.953-9.008
 c-1.312-2.357-2.602-4.653-3.837-6.818c-0.82-1.443-1.646-2.886-2.483-4.324c-0.278-0.475-0.551-0.951-0.835-1.427l0.01-0.208
 c0.482-15.547,1-34.909,1.082-37.943l0.012,0.005V42.432c0-0.383-0.241-0.733-0.618-0.875c-7.325-2.345-14.743-4.378-21.921-6.347
 c-2.958-0.814-5.932-1.629-8.928-2.471c-22.183-6.248-45.274-11.594-70.595-16.35c-0.629-0.115-1.121-0.126-1.526-0.028
 l-0.888,1.264l-1.31,6.406L51,34.19l-3.5,8.653l-1.349,2.075C19.873,93.161,29.265,134.84,31.413,142.7
 c0.224,0.831,0.382,1.685,0.459,2.537c0.432,4.565,1.416,17.214,1.323,35.993c-0.076,16.175,2.072,34.024,3.641,47.056
 c0.71,5.904,1.328,11.004,1.575,14.585c0.562,8.205-0.772,17.931-1.745,25.032c-0.393,2.859-0.732,5.329-0.863,7.095
 c-0.284,3.86-0.176,17.019-0.027,27.377c0.076,5.763-0.629,11.502-2.106,17.062c-2.7,10.195-6.313,24.807-8.172,36.528
 c-2.914,18.373-7.434,61.767-7.478,62.199c-0.071,0.552-7.03,55.623-7.479,64.703l-0.01,0.23l0.218,0.088
 c20.533,7.942,38.201,9.834,50.37,9.834c1.306,0,2.552-0.022,3.728-0.061c13.016-0.426,21.473-2.974,21.932-3.525
 c0.639-0.771,4.149-16.258,5.62-33.254c1.454-16.777,10.999-56.421,11.097-56.825c0.121-0.541,11.928-54.207,12.934-62.058
 c1.023-7.942,5.789-45.389,6.555-51.927c0.776-6.62,5.171-29.072,5.821-32.374c3.63,1.695,5.035,6.331,5.915,10.688
 c0.361,1.765,0.722,3.526,1.083,5.292c2.984,14.65,6.078,29.798,7.85,44.908c0.924,7.855,0.82,15.76,0.721,23.402
 c-0.048,3.527-0.098,7.167-0.044,10.786c0.121,8.55,0.493,17.05,0.865,25.021c0.513,11.042,1.082,20.839,1.732,29.951
 c1.115,15.668,1.241,52.174,1.241,52.54l0.011,0.061c0.05,0.267,0.782,2.645,10.808,3.984c10.545,1.405,21.123,1.849,36.96,2.165
 c0.519,0.011,1.027,0.017,1.536,0.017c15.881,0,25.928-4.981,26.032-5.036l0.158-0.082l0.017-0.174
 c0.021-0.262,2.142-26.071,1.241-34.27c-0.946-8.648-0.936-29.575,1.017-39.666c0.071-0.35,0.12-0.7,0.164-1.05
 c0.273-2.121,0.393-4.286,0.503-6.384l0.016-0.219c0.196-3.641,0.322-7.243,0.415-10.288c0.12-3.866,0.23-7.998,0.333-13.017
 c0.094-4.493,0.176-9.32,0.252-14.77c0.076-5.183,0.137-10.371,0.186-15.553c0.054-5.122,0.098-10.244,0.132-15.366
 c0.032-4.735,0.059-9.469,0.086-14.208c0.017-4.024,0.034-8.047,0.044-12.077l0.017-4.93c0-0.793,0.011-1.585,0.022-2.372
 C228.152,269.953,228.184,267.487,227.96,265.044z"
      />
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M467.023,238.572c-0.006-0.64-0.219-64.528-4.127-127.252c-3.783-60.669-12.89-77.451-13.591-78.659
 L447.83,14.32c-0.049-0.645-0.579-1.137-1.236-1.148c-76.5,1.498-150.064,0.935-165.579,0.706c-1.071,0-1.995,0.781-2.126,1.852
 l-2.093,17.138c-1.126,2.034-9.797,19.445-13.476,78.452c-0.606,9.779-1.164,20.183-1.65,30.908l-0.187,4.106
 c-0.41,9.511-0.781,19.461-1.099,29.574l-0.185,6.232c-0.93,32.428-1.001,56.192-1.006,56.426l-1.143,64.829
 c-0.038,2.17,0.028,4.368,0.203,6.532c0.486,6.085,0.759,19.812,0.978,30.843c0.164,8.102,0.301,15.094,0.482,17.335
 c0.513,6.281,1.574,47.259,1.585,47.669c0.016,0.564,1.344,56.088,1.853,64.933c0.514,8.932,1.377,17.083,1.924,18.177
 c0.41,0.82,14.12,2.651,27.573,3.389c13.432,0.743,31.926,0.798,43.755-3.149c0.258-0.087,0.448-0.306,0.498-0.574
 c0.929-5.243,5.116-42.005,5.811-62.73c0.677-20.412,0.311-71.427-0.235-77.965c-0.542-6.543,0.224-39.605,1.924-47.936
 c1.071-5.248,2.214-20.386,3.133-32.549c0.557-7.38,1.038-13.759,1.366-16.028c0.29-2.061,0.404-6.002,0.541-10.994
 c0.263-9.32,0.623-22.085,2.542-29.202c2.062-7.632,3.434-16.586,4.253-21.937c0.339-2.22,0.585-3.827,0.732-4.368
 c0.005-0.019,0.339-12.287,0.344-12.31l1.5-13.594l1.75-6.771l2.476-2.917l1.878,1.688l1.927,5.25c0,0,1.49,9.681,1.5,9.719
 c0.147,0.541,1.297,21.083,1.636,23.303c0.044,0.272,0.088,0.557,0.132,0.846c-0.012,0.247-0.017,0.394-0.022,0.411l0.087,0.005
 c0.836,5.423,2.149,13.612,4.056,20.675c1.919,7.117,2.28,19.882,2.542,29.202c0.143,4.992,0.252,8.933,0.547,10.994
 c0.322,2.274,0.81,8.791,1.372,16.339c0.919,12.382,2.066,27.788,3.138,33.03c1.712,8.391,2.116,41.519,1.58,47.937
 c-0.377,4.521,0.7,32.439,1.563,54.874c0.323,8.403,0.629,16.334,0.815,21.965c0.683,20.5,2.575,57.679,3.526,63.063
 c0.049,0.268,0.24,0.487,0.497,0.574c8.173,2.727,19.527,3.543,30.198,3.543c4.773,0,9.408-0.164,13.557-0.394
 c13.459-0.738,27.164-2.569,27.574-3.389c0.546-1.094,1.41-9.25,1.924-18.177c0.514-8.851,1.181-64.266,1.187-64.818
 c0.01-0.416,0.846-41.279,1.361-47.559c0.36-4.478,1.47-27.897,2.137-41.892c0.262-5.477,0.448-9.429,0.47-9.73l0.005-0.06
 L467.023,238.572z"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M297.564,159.514l-0.143,5.976l-0.054,5.389l-8.62-0.213l-26.782-0.738l-0.104-0.021h-0.634
 c0.071-2.193,0.148-4.374,0.225-6.544L297.564,159.514z"
      />
      <polygon
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        points="449.137,86.042 439.904,86.349 411.237,87.224 411.073,87.212 385.248,88.606 376.141,89.065 
 376.042,86.338 448.694,75.918 448.885,81.243 "
      />
      <polygon
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        points="349.3,86.338 349.207,89.06 340.094,88.607 314.215,87.212 314.154,87.224 285.445,86.349 
 276.211,86.042 276.457,81.237 276.632,75.918 "
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M372.303,14.72l-5.095,25.698c-0.038,0.323-0.141,0.487-0.153,0.509l-9.375,0.005
 c-0.044-0.027-0.158-0.191-0.202-0.547l-5.33-25.583C358.604,14.785,365.344,14.758,372.303,14.72"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.321"
        strokeMiterlimit="10"
        strokeDasharray="1.284,0.963"
        d="
 M462.218,477.234c0,0-31.966,9.482-73.799,0"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.321"
        strokeMiterlimit="10"
        x1="353.474"
        y1="14.228"
        x2="353.519"
        y2="14.6"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.321"
        strokeMiterlimit="10"
        x1="353.609"
        y1="15.346"
        x2="353.609"
        y2="15.347"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.321"
        strokeMiterlimit="10"
        strokeDasharray="0.966,0.965"
        x1="353.609"
        y1="15.347"
        x2="359.069"
        y2="40.727"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.321"
        strokeMiterlimit="10"
        strokeDasharray="0.963,0.963"
        d="
 M369.214,184.769c0,0,1.548-30.869,1.173-34.355c-0.375-3.487-5.099-5.714-7.301-5.057h-0.096c-2.202-0.657-6.925,1.57-7.3,5.057
 c-0.374,3.486,1.172,34.355,1.172,34.355"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.321"
        strokeMiterlimit="10"
        strokeDasharray="1.284,0.963"
        d="
 M263.779,477.234c0,0,32.675,9.436,74.509-0.047"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.321"
        strokeMiterlimit="10"
        strokeDasharray="0.963,0.963"
        d="
 M357.807,166.346v-13.043c0-1.677,0.625-3.311,1.808-4.498c0.813-0.817,1.836-1.259,3.313-1.274"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.321"
        strokeMiterlimit="10"
        strokeDasharray="0.963,0.963"
        d="
 M368.362,166.461l-0.182-13.225c0-1.676-0.624-3.31-1.807-4.498c-0.814-0.817-1.835-1.258-3.313-1.274"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.321"
        strokeMiterlimit="10"
        x1="370.906"
        y1="14.228"
        x2="370.866"
        y2="14.6"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.321"
        strokeMiterlimit="10"
        x1="370.784"
        y1="15.346"
        x2="370.784"
        y2="15.347"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.321"
        strokeMiterlimit="10"
        strokeDasharray="0.966,0.965"
        x1="370.784"
        y1="15.347"
        x2="365.624"
        y2="40.727"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.321"
        strokeMiterlimit="10"
        strokeDasharray="0.966,0.965"
        x1="363.739"
        y1="59.766"
        x2="455.823"
        y2="55.556"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.321"
        strokeMiterlimit="10"
        strokeDasharray="0.966,0.965"
        points="
 270.395,55.556 362.082,59.755 362.159,59.759 "
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.321"
        strokeMiterlimit="10"
        strokeDasharray="0.966,0.965"
        x1="363.626"
        y1="58.18"
        x2="455.823"
        y2="53.97"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.321"
        strokeMiterlimit="10"
        x1="270.395"
        y1="53.97"
        x2="270.876"
        y2="53.991"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.321"
        strokeMiterlimit="10"
        strokeDasharray="0.958,0.957"
        x1="271.834"
        y1="54.035"
        x2="359.924"
        y2="58.029"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.321"
        strokeMiterlimit="10"
        points="359.924,58.029 360.406,58.05 
 360.407,57.568 "
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.321"
        strokeMiterlimit="10"
        strokeDasharray="1.011,1.009"
        x1="360.41"
        y1="56.558"
        x2="360.453"
        y2="42.409"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.321"
        strokeMiterlimit="10"
        x1="360.453"
        y1="42.408"
        x2="360.453"
        y2="41.925"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.321"
        strokeMiterlimit="10"
        x1="361.868"
        y1="59.72"
        x2="361.867"
        y2="59.237"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.321"
        strokeMiterlimit="10"
        strokeDasharray="0.983,0.982"
        x1="361.863"
        y1="58.253"
        x2="361.814"
        y2="42.522"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.321"
        strokeMiterlimit="10"
        x1="361.815"
        y1="42.522"
        x2="361.813"
        y2="42.039"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.321"
        strokeMiterlimit="10"
        strokeDasharray="0.966,0.965"
        x1="361.868"
        y1="62.05"
        x2="361.868"
        y2="142.797"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.321"
        strokeMiterlimit="10"
        strokeDasharray="0.966,0.965"
        x1="360.282"
        y1="62.05"
        x2="360.282"
        y2="143.08"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="260.4"
        y1="231.72"
        x2="261.027"
        y2="231.731"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="262.275"
        y1="231.754"
        x2="262.285"
        y2="231.754"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.259,1.248,0.01,0"
        d="
 M262.285,231.754l0.396,0.007l29.674,0.737c1.061,0.027,1.922-0.848,1.94-1.972l0.932-57.474"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="295.228"
        y1="173.052"
        x2="295.238"
        y2="172.424"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="260.324"
        y1="228.999"
        x2="260.952"
        y2="229.009"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="262.207"
        y1="229.03"
        x2="262.217"
        y2="229.03"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.266,1.255,0.01,0"
        d="
 M262.217,229.03l0.512,0.009l28.093,0.685c0.709,0.017,1.286-0.568,1.297-1.319l0.903-55.387"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="293.022"
        y1="173.019"
        x2="293.031"
        y2="172.391"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="261.357"
        y1="164.422"
        x2="297.873"
        y2="160.744"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="260.488"
        y1="215.041"
        x2="290.963"
        y2="215.713"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="260.564"
        y1="212.776"
        x2="291"
        y2="213.436"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="
 M295.672,142.077c-6.511-0.2-13.008-0.398-19.49-0.601c-4.74-0.147-9.489-0.224-14.234-0.253"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="295.978"
        y1="141.853"
        x2="295.438"
        y2="157.416"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="295.464"
        y1="161.736"
        x2="295.233"
        y2="170.148"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.329"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        points="
 296.61,140.917 295.817,142.688 296.029,140.925 294.854,142.691 295.065,140.93 294.084,142.697 294.295,140.936 293.313,142.703 
 293.523,140.941 292.544,142.708 292.753,140.948 291.774,142.714 291.983,140.954 291.005,142.72 "
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M282.616,14.332
 c0,0-1.125,26.007-1.217,26.233"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M285.855,14.332
 c0,0-1.125,26.007-1.217,26.233"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M444.586,13.652
 c0,0,1.124,26.007,1.217,26.233"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M441.346,13.652
 c0,0,1.125,26.007,1.218,26.233"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M347.152,90.419
 c-0.008,0.211-0.015,0.42-0.022,0.628"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="347.084"
        y1="92.299"
        x2="347.084"
        y2="92.313"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.264,1.253,0.01,0"
        d="
 M347.084,92.313c-0.451,12.151-0.816,18.934-1.383,31.159c-0.219,4.733,0.053,2.87-0.07,5.649c-0.014,0.328-0.321,0.586-0.681,0.57
 l-34.309-1.432l-31.782-1.146c-1.134-0.041-2.004-0.879-1.959-1.887l1.489-37.02"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="278.388"
        y1="88.209"
        x2="278.413"
        y2="87.582"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M344.834,90.323
 c-0.008,0.212-0.016,0.422-0.023,0.629"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="344.766"
        y1="92.186"
        x2="344.765"
        y2="92.198"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.246,1.235"
        d="M344.765,92.197
 c-0.448,11.944-0.767,16.526-1.335,28.753c-0.213,4.576,0.064,2.609-0.059,5.368c-0.021,0.483-0.474,0.86-1.003,0.838l-31.622-1.347
 l-30.092-1.092c-0.757-0.028-1.339-0.588-1.31-1.262l1.4-35.151"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="280.744"
        y1="88.307"
        x2="280.769"
        y2="87.68"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="349.011"
        y1="87.046"
        x2="276.271"
        y2="76.973"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="348.635"
        y1="62.088"
        x2="347.383"
        y2="84.949"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="342.531"
        y1="116.163"
        x2="341.904"
        y2="116.139"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="340.676"
        y1="116.093"
        x2="340.666"
        y2="116.093"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.239,1.228"
        x1="340.666"
        y1="116.093"
        x2="281.255"
        y2="113.863"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="281.255"
        y1="113.862"
        x2="280.627"
        y2="113.839"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="342.616"
        y1="114.13"
        x2="341.989"
        y2="114.107"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="340.762"
        y1="114.06"
        x2="340.752"
        y2="114.06"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.239,1.228"
        x1="340.752"
        y1="114.06"
        x2="281.346"
        y2="111.819"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="281.346"
        y1="111.818"
        x2="280.719"
        y2="111.795"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="279.424"
        y1="59.143"
        x2="279.408"
        y2="59.771"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="279.378"
        y1="61.008"
        x2="279.377"
        y2="61.019"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.249,1.238"
        x1="279.377"
        y1="61.019"
        x2="279.073"
        y2="73.504"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="279.073"
        y1="73.504"
        x2="279.057"
        y2="74.131"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="278.783"
        y1="77.998"
        x2="278.549"
        y2="85.545"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M378.191,90.419
 c0.008,0.211,0.016,0.42,0.022,0.628"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        d="M378.26,92.299
 c0,0.005,0,0.009,0.001,0.014"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.264,1.253,0.01,0"
        d="
 M378.261,92.313c0.45,12.151,0.815,18.934,1.382,31.159c0.22,4.733-0.053,2.87,0.07,5.649c0.014,0.328,0.322,0.586,0.681,0.57
 l34.309-1.432l31.783-1.146c1.133-0.041,2.003-0.879,1.958-1.887l-1.488-37.02"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="446.956"
        y1="88.209"
        x2="446.932"
        y2="87.582"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M380.51,90.323
 c0.008,0.212,0.016,0.422,0.023,0.629"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="380.578"
        y1="92.186"
        x2="380.579"
        y2="92.198"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.246,1.235"
        d="M380.579,92.197
 c0.448,11.944,0.768,16.526,1.335,28.753c0.213,4.576-0.063,2.609,0.059,5.368c0.021,0.483,0.474,0.86,1.003,0.838l31.622-1.347
 l30.092-1.092c0.758-0.028,1.339-0.588,1.31-1.262l-1.4-35.151"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="444.6"
        y1="88.307"
        x2="444.576"
        y2="87.68"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="376.334"
        y1="87.046"
        x2="449.073"
        y2="76.973"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="376.709"
        y1="62.088"
        x2="377.962"
        y2="84.949"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="382.814"
        y1="116.163"
        x2="383.44"
        y2="116.139"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="384.668"
        y1="116.093"
        x2="384.678"
        y2="116.093"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.239,1.228"
        x1="384.678"
        y1="116.093"
        x2="444.09"
        y2="113.863"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="444.09"
        y1="113.862"
        x2="444.717"
        y2="113.839"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="382.728"
        y1="114.13"
        x2="383.355"
        y2="114.107"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="384.582"
        y1="114.06"
        x2="384.592"
        y2="114.06"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.239,1.228"
        x1="384.592"
        y1="114.06"
        x2="443.998"
        y2="111.819"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="443.998"
        y1="111.818"
        x2="444.625"
        y2="111.795"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="445.92"
        y1="59.143"
        x2="445.936"
        y2="59.771"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="445.967"
        y1="61.008"
        x2="445.967"
        y2="61.019"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.249,1.238"
        x1="445.967"
        y1="61.019"
        x2="446.272"
        y2="73.504"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="446.272"
        y1="73.504"
        x2="446.286"
        y2="74.131"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="446.56"
        y1="77.998"
        x2="446.794"
        y2="85.545"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="288.693"
        y1="15.645"
        x2="350.202"
        y2="15.645"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="287.685"
        y1="31.541"
        x2="353.609"
        y2="32.763"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="370.784"
        y1="33.089"
        x2="439.011"
        y2="31.503"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="374.167"
        y1="15.645"
        x2="437.803"
        y2="15.346"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="279.921"
        y1="31.541"
        x2="278.046"
        y2="31.391"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="280.727"
        y1="15.645"
        x2="279.921"
        y2="15.645"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="446.261"
        y1="15.346"
        x2="446.915"
        y2="15.346"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="447.065"
        y1="31.365"
        x2="448.186"
        y2="31.277"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M440.115,185.5
 c0.004,0.211,0.008,0.42,0.012,0.628"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="440.148"
        y1="187.353"
        x2="440.148"
        y2="187.366"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.235,1.224"
        d="
 M440.148,187.365c0.257,13.723,0.516,21.186,0.9,34.899c0.133,4.701,0.245,8.676,0.324,11.675c0.024,0.948,0.815,1.695,1.763,1.667
 l22.322-0.637"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="465.453"
        y1="234.969"
        x2="466.08"
        y2="234.951"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M442.72,185.438
 c0.004,0.212,0.007,0.422,0.011,0.63"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="442.754"
        y1="187.33"
        x2="442.755"
        y2="187.341"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.275,1.263,0.01,0"
        d="
 M442.755,187.341c0.255,13.472,0.507,18.454,0.892,32.149c0.132,4.702,0.244,8.676,0.323,11.675
 c0.024,0.948,0.815,1.696,1.764,1.667l19.704-0.572"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="465.435"
        y1="232.26"
        x2="466.062"
        y2="232.241"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="439.018"
        y1="182.24"
        x2="465.631"
        y2="181.609"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        points="
 464.586,171.587 438.78,172.199 438.455,158.509 "
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="438.718"
        y1="169.594"
        x2="464.385"
        y2="168.986"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        points="
 455.768,155.379 454.794,114.313 462.275,118.878 "
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="454.794"
        y1="114.313"
        x2="453.591"
        y2="113.457"
      />
      <path
        fill={patchColor}
        onClick={() => handleClick("patch")}
        onMouseEnter={() => setPatchActive(true)}
        onMouseLeave={() => setPatchActive(false)}
        style={
          patchActive && !preview ? {fill: adjust(patchColor, 55)} : {fill: patchColor}
        }
        d="M227.509,272.317c-0.012,0.793-0.017,1.586-0.022,2.378l-0.011,4.936c-0.011,4.024-0.028,8.047-0.049,12.077
 c-0.022,4.734-0.05,9.467-0.082,14.202c-0.038,5.122-0.082,10.244-0.132,15.366c-0.055,5.183-0.114,10.365-0.185,15.553
 c-0.082,5.445-0.165,10.272-0.257,14.765c-0.017,0.728-0.028,1.438-0.044,2.132c-22.118,1.498-41.459,0.438-44.548,0.252
 c-0.371-6.839-0.863-12.775-1.503-17.286c-4.253-29.989-4.75-56.224-4.756-56.52c-0.044-0.343-2.651-20.384-6.872-41.901
 c3.937-0.082,27.404-0.77,50.512-5.374c0.296,0.924,0.585,1.843,0.869,2.761c1.602,5.199,2.931,9.999,4.062,14.673l0.153,0.623
 c1.115,4.625,2.274,9.408,2.712,14.131C227.579,267.49,227.541,269.945,227.509,272.317"
      />
      <path
        fill={patchColor}
        onClick={() => handleClick("patch")}
        onMouseEnter={() => setPatchActive(true)}
        onMouseLeave={() => setPatchActive(false)}
        style={
          patchActive && !preview ? {fill: adjust(patchColor, 55)} : {fill: patchColor}
        }
        d="M128.256,252.616c-0.442,2.252-5.072,25.83-5.876,32.657c-0.766,6.538-5.527,43.985-6.549,51.922
 c-0.46,3.56-3.154,16.613-5.965,29.826c-27.169-1.475-53.763-6.062-57.454-6.713c3.598-22.265,7.282-42.629,10.6-56.377
 c2.712-11.212,5.505-29.367,9.25-60.128c2.887,0.531,30.17,5.446,55.973,7.965C128.191,252.244,128.207,252.484,128.256,252.616"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M139.523,56.856c-9.474,15.892-26.476,33.182-53.404,54.316c0.475-5.297,0.929-10.403,1.356-15.268
 c20.724-13.049,36.424-26.175,47.997-40.12C136.855,56.145,138.206,56.505,139.523,56.856"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M54.872,16.955c-0.093,0.12-0.169,0.257-0.24,0.41l-0.777,0.006c-0.415-0.061-0.797,0.24-0.869,0.678
 c-2.34,13.895-6.062,21.915-6.1,21.997l-0.028,0.115c-0.006,0.076-0.027,0.793,0.7,1.799l-0.251,0.535
 c-0.673-0.497-0.947-0.918-0.962-0.94c-0.564-0.765-0.438-1.208-0.438-1.208c0.022-0.049,1.093-2.372,2.449-6.429
 c1.356-4.062,2.995-9.851,4.171-16.843c0.011-0.076,0.038-0.141,0.197-0.141l1.274-0.006L54.872,16.955z"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M71.431,86.671l-0.295,4.313l-0.181,3.881l-6.614-0.448c-11.283-0.792-22.069-1.443-33.893-2.044
 c0.185-1.142,0.388-2.296,0.601-3.466c7.904-0.366,16.088-0.841,24.01-1.306C60.459,87.283,66.041,86.955,71.431,86.671"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M90.366,45.23
 c-0.407,5.061-3.221,39.808-6.646,77.531l-0.989,12.503"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M32.775,489.75c0,0,0.026-0.214,0.077-0.629"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="33.01"
        y1="487.859"
        x2="33.01"
        y2="487.858"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.273,1.272"
        d="M33.01,487.858
 c2.064-16.565,17.316-137.439,28.56-184.001c3.828-15.851,6.074-30.06,10.061-65.398"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M150.322,167.284
 c0.008,0.181,0.02,0.391,0.036,0.633"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="150.474"
        y1="169.179"
        x2="150.474"
        y2="169.18"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.269,1.268"
        d="M150.474,169.18
 c0.397,3.704,1.717,11.83,5.87,29.135c10.649,24.354,18.351,84.277,18.351,84.277s0.453,26.167,4.758,56.525
 c3.847,27.138,2.373,105.127,2.016,121.365"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M181.469,460.481
 c-0.005,0.224-0.01,0.435-0.014,0.634"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M149.189,171.654
 c0.029,0.201,0.06,0.41,0.093,0.627"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="149.479"
        y1="173.536"
        x2="149.479"
        y2="173.537"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.272,1.271"
        d="
 M149.479,173.537c0.766,4.717,2.287,12.421,5.279,24.891c10.649,24.354,18.351,84.277,18.351,84.277s0.453,26.167,4.758,56.525
 c3.836,27.055,2.382,104.649,2.02,121.213"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M179.887,460.444
 c-0.005,0.222-0.01,0.434-0.015,0.633"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M148.421,174.555
 c0.035,0.203,0.071,0.411,0.108,0.624"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="148.752"
        y1="176.428"
        x2="148.752"
        y2="176.429"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.27,1.269"
        d="M148.752,176.429
 c0.873,4.792,2.333,11.771,4.76,21.886c10.648,24.354,18.351,84.277,18.351,84.277s0.452,26.167,4.757,56.525
 c3.84,27.076,2.38,104.769,2.02,121.251"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M178.64,460.369
 c-0.005,0.222-0.01,0.434-0.015,0.633"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M89.162,477.916c0,0-0.215,0.043-0.623,0.117"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="87.271"
        y1="478.254"
        x2="87.27"
        y2="478.254"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.288,1.287"
        d="M87.271,478.254
 c-6.901,1.153-31.365,4.545-51.1-1.449"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M36.169,476.804
 c-0.202-0.062-0.403-0.124-0.605-0.187"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M30.721,475.274c0,0-0.218-0.064-0.606-0.182"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="28.948"
        y1="474.739"
        x2="28.947"
        y2="474.739"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.219,1.218"
        d="M28.947,474.739
 c-3.825-1.166-12.774-3.963-16.124-5.583"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M12.822,469.156
 c-0.211-0.103-0.399-0.199-0.562-0.291"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.268,1.268"
        d="
 M224.154,446.003c0,0-19.741,7.235-41.624,4.32"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.268,1.268"
        d="
 M177.866,449.788c0,0-20.76-1.309-29.41-4.393"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.426"
        strokeMiterlimit="10"
        strokeDasharray="1.279,1.279"
        d="M71.501,247.748
 c0,0,28.481,7.008,56.314,7.929"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.268,1.268"
        d="
 M169.371,241.473c0,0,25.593-0.349,51.341-5.605"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.445"
        strokeMiterlimit="10"
        strokeDasharray="1.335,1.335"
        d="M52.536,356.133
 c0,0,29.062,5.004,57.948,6.703"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.444"
        strokeMiterlimit="10"
        strokeDasharray="1.333,1.333"
        d="
 M181.491,350.305c0,0,21.335,1.375,45.686-0.277"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M87.489,67.978
 c-10.052-0.92-38.033-2.972-50.663-1.139"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M87.716,66.279
 c-9.735-0.895-37.314-3.143-50.248-1.453"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M80.488,21.175
 c0,0-3.479,25.793-3.435,26.031"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M77.591,20.668
 c0,0-3.479,25.793-3.435,26.03"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M112.205,28.651
 c0,0-3.479,25.793-3.435,26.03"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M109.308,28.145
 c0,0-3.479,25.793-3.435,26.03"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M31.523,138.286
 c0.209,0.008,0.418,0.016,0.627,0.024"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="33.412"
        y1="138.362"
        x2="33.422"
        y2="138.362"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.274,1.262,0.01,0"
        d="
 M33.422,138.362c10.813,0.456,21.615,1.224,32.42,1.563c0.238,0,0.357-0.119,0.596-0.239c0.475-0.36,0.475-0.72,0.594-1.199
 c0.939-14.062,1.532-27.891,2.265-41.841"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M69.297,96.647
 c0.012-0.209,0.021-0.418,0.033-0.627"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M31.543,136.285
 c0.209,0.006,0.418,0.011,0.627,0.017"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="33.417"
        y1="136.341"
        x2="33.426"
        y2="136.341"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.259,1.248,0.01,0"
        d="
 M33.426,136.341c10.441,0.347,20.893,1.313,31.344,1.427c0.595,0,0.595-0.72,0.715-1.32c0.82-13.341,1.41-26.567,2.101-39.896"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M67.586,96.549
 c0.01-0.21,0.021-0.419,0.032-0.628"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M31.19,89.501
 c13.346-0.63,27.146-1.385,40.498-1.997"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M29.823,125.784
 c0.208,0.011,0.417,0.022,0.626,0.033"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="31.69"
        y1="125.884"
        x2="31.698"
        y2="125.884"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.254,1.243"
        d="M31.697,125.884
 c10.438,0.552,22.248,1.106,32.541,1.753"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M64.242,127.637
 c0.208,0.013,0.416,0.026,0.624,0.039"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M29.833,124.105
 c0.208,0.014,0.417,0.027,0.626,0.04"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="31.701"
        y1="124.223"
        x2="31.711"
        y2="124.223"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.257,1.246,0.01,0"
        d="
 M31.711,124.223c10.521,0.639,22.242,1.094,32.617,1.748"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M64.33,125.971
 c0.209,0.013,0.417,0.026,0.625,0.039"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="71.064"
        y1="69.451"
        x2="69.888"
        y2="84.958"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="69.792"
        y1="88.148"
        x2="69.387"
        y2="94.343"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M86.696,109.098
 c24.183-18.922,40.797-34.47,51.46-52.682"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="157.699"
        y1="43.171"
        x2="114.336"
        y2="30.824"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="157.699"
        y1="59.667"
        x2="112.523"
        y2="47.589"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="106.52"
        y1="28.898"
        x2="82.731"
        y2="23.419"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M104.457,45.705
 c0,0-13.683-3.44-24.331-4.8"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="74.915"
        y1="21.875"
        x2="56.338"
        y2="18.363"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M72.197,39.546
 c0,0-8.496-1.359-19.937-3.285"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M56.625,190.275
 c-0.017,0.21-0.033,0.419-0.049,0.626"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M56.479,192.133
 c0,0.005-0.001,0.009-0.002,0.014"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.246,1.235"
        d="M56.477,192.147
 c-0.854,10.86-1.239,16.891-2.008,27.863c-0.265,3.803-0.49,10.531-0.664,12.956c-0.055,0.767,0.481,1.436,1.193,1.493l32.641,2.689
 l34.419,2.298c0.776,0.066,1.456-0.557,1.517-1.391l2.839-41.763"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="126.413"
        y1="196.296"
        x2="126.455"
        y2="195.67"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M58.584,190.442
 c-0.016,0.212-0.033,0.421-0.049,0.628"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="58.437"
        y1="192.315"
        x2="58.435"
        y2="192.325"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.259,1.248,0.01,0"
        d="
 M58.436,192.325c-0.832,10.631-1.034,14.701-1.801,25.664c-0.266,3.803-0.492,10.53-0.666,12.955
 c-0.054,0.768,0.481,1.437,1.196,1.492L87.8,234.95l32.454,2.129c0.777,0.066,1.456-0.557,1.518-1.391l2.675-39.563"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="124.447"
        y1="196.128"
        x2="124.49"
        y2="195.501"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="56.056"
        y1="187.554"
        x2="127.247"
        y2="193.066"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        points="
 128.385,173.605 127.546,184.92 56.657,179.435 57.478,168.365 "
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="56.813"
        y1="177.328"
        x2="127.702"
        y2="182.813"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        points="
 70.983,167.374 73.444,134.166 118.499,164.853 118.061,170.755 "
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="118.499"
        y1="164.853"
        x2="119.631"
        y2="165.78"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="73.444"
        y1="134.166"
        x2="72.607"
        y2="133.375"
      />
      <path
        d="M227.995,265.025c-0.443-4.767-1.607-9.572-2.727-14.225l-0.154-0.623c-1.131-4.684-2.465-9.495-4.073-14.705
 c-1.519-4.926-3.197-9.938-5.138-15.323c-1.798-4.991-3.805-10.244-5.964-15.612c-2.023-5.019-4.226-10.272-6.549-15.602
 c-2.159-4.947-4.478-10.092-6.888-15.285c-2.22-4.777-4.57-9.703-6.986-14.65c-2.203-4.499-4.505-9.108-6.845-13.705
 c-2.099-4.117-4.269-8.304-6.456-12.448c-1.907-3.619-3.87-7.281-5.827-10.884c-1.651-3.05-3.318-6.079-4.953-9.008
 c-1.312-2.357-2.602-4.653-3.837-6.818c-0.82-1.443-1.646-2.886-2.483-4.324c-0.278-0.475-0.551-0.951-0.835-1.427l0.01-0.208
 c0.482-15.547,1-34.909,1.082-37.943l0.012,0.005V42.413c0-0.383-0.241-0.733-0.618-0.875c-7.325-2.345-14.743-4.378-21.921-6.347
 c-2.958-0.814-5.932-1.629-8.928-2.471c-22.183-6.248-45.274-11.594-70.595-16.35c-0.629-0.115-1.121-0.126-1.526-0.028
 l-1.793-0.054h-1.279c-0.443,0-0.76,0.262-0.831,0.683c-2.334,13.902-6.527,23.015-6.571,23.113
 c-0.033,0.077-0.29,0.765,0.493,1.832c0.015,0.021,0.355,0.557,1.213,1.174l-0.842,1.81C19.908,93.143,29.3,134.821,31.448,142.681
 c0.224,0.831,0.382,1.685,0.459,2.537c0.432,4.565,1.416,17.214,1.323,35.993c-0.076,16.175,2.072,34.024,3.641,47.056
 c0.71,5.904,1.328,11.004,1.575,14.585c0.562,8.205-0.772,17.931-1.745,25.032c-0.393,2.859-0.732,5.329-0.863,7.095
 c-0.284,3.86-0.176,17.019-0.027,27.377c0.076,5.763-0.629,11.502-2.106,17.062c-2.7,10.195-6.313,24.807-8.172,36.528
 c-2.914,18.373-7.434,61.767-7.478,62.199c-0.071,0.552-7.03,55.623-7.479,64.703l-0.01,0.23l0.218,0.088
 C31.317,491.108,48.985,493,61.154,493c1.306,0,2.552-0.022,3.728-0.061c13.016-0.426,21.473-2.974,21.932-3.525
 c0.639-0.771,4.149-16.258,5.62-33.254c1.454-16.777,10.999-56.421,11.097-56.825c0.121-0.541,11.928-54.207,12.934-62.058
 c1.023-7.942,5.789-45.389,6.555-51.927c0.776-6.62,5.171-29.072,5.821-32.374c3.63,1.695,5.035,6.331,5.915,10.688
 c0.361,1.765,0.722,3.526,1.083,5.292c2.984,14.65,6.078,29.798,7.85,44.908c0.924,7.855,0.82,15.76,0.721,23.402
 c-0.048,3.527-0.098,7.167-0.044,10.786c0.121,8.55,0.493,17.05,0.865,25.021c0.513,11.042,1.082,20.839,1.732,29.951
 c1.115,15.668,1.241,52.174,1.241,52.54l0.011,0.061c0.05,0.267,0.782,2.645,10.808,3.984c10.545,1.405,21.123,1.849,36.96,2.165
 c0.519,0.011,1.027,0.017,1.536,0.017c15.881,0,25.928-4.981,26.032-5.036l0.158-0.082l0.017-0.174
 c0.021-0.262,2.142-26.071,1.241-34.27c-0.946-8.648-0.936-29.575,1.017-39.666c0.071-0.35,0.12-0.7,0.164-1.05
 c0.273-2.121,0.393-4.286,0.503-6.384l0.016-0.219c0.196-3.641,0.322-7.243,0.415-10.288c0.12-3.866,0.23-7.998,0.333-13.017
 c0.094-4.493,0.176-9.32,0.252-14.77c0.076-5.183,0.137-10.371,0.186-15.553c0.054-5.122,0.098-10.244,0.132-15.366
 c0.032-4.735,0.059-9.469,0.086-14.208c0.017-4.024,0.034-8.047,0.044-12.077l0.017-4.93c0-0.793,0.011-1.585,0.022-2.372
 C228.187,269.934,228.219,267.468,227.995,265.025 M158.564,102.135c0.831,1.439,1.656,2.876,2.476,4.32
 c1.23,2.164,2.52,4.455,3.837,6.811c1.629,2.93,3.291,5.958,4.947,9.003c1.957,3.603,3.914,7.26,5.823,10.879
 c2.186,4.138,4.357,8.325,6.45,12.442c2.34,4.586,4.641,9.195,6.839,13.694c2.417,4.942,4.761,9.862,6.981,14.639
 c2.41,5.188,4.729,10.322,6.882,15.263c2.324,5.33,4.526,10.572,6.544,15.591c2.154,5.357,4.16,10.605,5.953,15.591
 c1.498,4.149,2.837,8.074,4.067,11.912c-23.271,4.63-46.892,5.28-50.44,5.351c-3.072-15.536-6.976-31.744-11.365-41.797
 c-6.631-27.628-6.025-31.734-5.997-31.887l-0.17-0.044l0.17,0.033c2.925-15.624,5.553-37.578,6.008-44.329
 c0.153-2.22,0.404-9.419,0.672-18.013C158.351,101.775,158.454,101.956,158.564,102.135 M127.742,33.338
 c2.996,0.842,5.97,1.663,8.933,2.471c7.167,1.968,14.58,4.002,21.883,6.336c0.109,0.038,0.186,0.148,0.186,0.268v18.98
 c-1.788-0.492-9.26-2.542-18.74-5.073l-0.12-0.065c-0.006,0.01-0.011,0.021-0.017,0.032c-8.882-2.372-19.504-5.15-28.885-7.462
 l2.465-19.352C118.264,30.725,123.025,32.009,127.742,33.338 M104.799,55.347l4.406,0.771c0.038,0.005,0.076,0.011,0.12,0.011
 c0.148,0,0.301-0.049,0.432-0.148c0.219-0.158,0.361-0.421,0.399-0.716l0.744-5.801c7.68,1.892,16.187,4.101,23.883,6.134
 c-11.43,13.716-26.889,26.645-47.237,39.496c2.406-27.442,3.958-47.061,4.183-49.887c3.127,0.579,8.003,1.633,13.202,2.858
 l-0.749,6.271C104.115,54.838,104.384,55.276,104.799,55.347 M135.473,55.784c1.383,0.361,2.733,0.721,4.051,1.072
 c-9.474,15.892-26.476,33.182-53.405,54.316c0.476-5.297,0.93-10.403,1.357-15.268C108.199,82.855,123.9,69.729,135.473,55.784
  M112.824,29.309l-3.301,25.874c-0.023,0.142-0.088,0.24-0.143,0.279c-0.011,0.01-0.044,0.027-0.059,0.022l-4.407-0.771
 c-0.038-0.005-0.12-0.115-0.098-0.301l3.154-26.338C109.594,28.484,111.211,28.894,112.824,29.309 M107.341,27.916l-2.334,19.505
 c-5.379-1.263-10.408-2.346-13.514-2.915c-1.557-0.278-3.121-0.562-4.684-0.841c-1.624-0.29-3.247-0.575-4.871-0.859
 c-0.388-0.071-1.006-0.169-1.618-0.267c-0.427-0.072-0.848-0.143-1.187-0.198l2.608-20.39
 C90.488,23.842,99.005,25.822,107.341,27.916 M81.107,21.815l-3.302,25.89c-0.022,0.141-0.087,0.24-0.142,0.284
 c-0.011,0.006-0.044,0.027-0.06,0.021l-4.406-0.77c-0.039-0.006-0.121-0.12-0.099-0.306l3.133-26.158
 C77.865,21.121,79.488,21.464,81.107,21.815 M57.201,17.004c6.265,1.175,12.388,2.383,18.396,3.641l-2.472,20.663
 c-0.097-0.021-0.196-0.038-0.305-0.059c-0.301-0.066-0.602-0.126-0.701-0.143c-1.563-0.268-3.131-0.535-4.701-0.798
 c-1.465-0.246-2.93-0.497-4.394-0.738c-1.329-0.224-2.652-0.442-3.975-0.661c-1.143-0.192-2.285-0.377-3.428-0.569
 c-0.918-0.147-1.841-0.295-2.76-0.443l-0.487-0.076c-0.519-0.088-1.039-0.17-1.557-0.246c-0.198-0.028-0.389-0.055-0.591-0.076
 c1.399-3.554,2.487-7.555,3.433-12.574l0.339-1.668c0.279-1.377,0.558-2.803,0.853-4.373c0.153-0.797,0.322-1.393,0.656-1.7
 C55.823,16.9,56.349,16.84,57.201,17.004 M49.542,37.722l-1.667,3.559c-0.311-0.525-0.366-0.907-0.377-1.033
 c0.371-0.815,3.881-8.785,6.117-22.096c0.017-0.093,0.087-0.158,0.197-0.143l0.585-0.004c-0.066,0.235-0.126,0.486-0.175,0.765
 c-0.295,1.558-0.574,2.985-0.853,4.357l-0.344,1.672c-0.941,5.03-2.034,9.02-3.433,12.557
 C49.531,37.504,49.527,37.624,49.542,37.722 M46.345,41.554c-0.564-0.764-0.438-1.208-0.438-1.208
 c0.022-0.049,1.093-2.372,2.45-6.428c1.355-4.062,2.995-9.851,4.171-16.843c0.01-0.076,0.038-0.142,0.196-0.142l1.274-0.006
 l0.874,0.028c-0.092,0.12-0.169,0.257-0.24,0.41l-0.776,0.006c-0.415-0.061-0.798,0.24-0.869,0.677
 c-2.34,13.896-6.063,21.915-6.101,21.998l-0.027,0.115c-0.006,0.076-0.028,0.793,0.699,1.799l-0.251,0.535
 C46.634,41.998,46.361,41.577,46.345,41.554 M46.754,45.19l3.308-7.068c0.218,0.027,0.437,0.054,0.662,0.087
 c0.514,0.077,1.033,0.159,1.547,0.241l0.491,0.082c0.919,0.147,1.837,0.295,2.756,0.442c1.142,0.192,2.285,0.377,3.422,0.564
 c1.328,0.223,2.651,0.442,3.974,0.661c1.465,0.246,2.936,0.492,4.401,0.743c1.563,0.263,3.132,0.53,4.695,0.799
 c0.099,0.015,0.389,0.076,0.684,0.137c0.126,0.021,0.246,0.048,0.355,0.07l-0.585,4.909c-0.059,0.509,0.208,0.94,0.618,1.017
 l4.406,0.771c0.039,0.005,0.082,0.005,0.121,0.005c0.147,0,0.299-0.049,0.431-0.147c0.219-0.159,0.361-0.421,0.399-0.716
 l0.612-4.806c0.34,0.055,0.749,0.12,1.165,0.191c0.606,0.099,1.225,0.198,1.612,0.269c1.624,0.284,3.247,0.568,4.871,0.857
 c1.465,0.263,2.93,0.526,4.395,0.793c-0.131,1.684-0.842,10.627-1.984,24.289c-3.685-0.372-37.539-3.685-52.453-1.482
 C39.216,60.579,42.518,52.969,46.754,45.19 M36.423,68.588c8.675-1.362,24.223-0.739,36.232,0.07l-1.18,17.362
 c-5.418,0.284-11.027,0.612-16.455,0.93c-7.866,0.459-15.995,0.934-23.845,1.306C32.372,82.018,34.067,75.431,36.423,68.588
  M31.049,88.907c7.904-0.366,16.088-0.842,24.01-1.307c5.4-0.317,10.982-0.645,16.372-0.929l-0.295,4.313l-0.181,3.881l-6.614-0.448
 c-11.283-0.792-22.069-1.444-33.894-2.044C30.633,91.23,30.836,90.077,31.049,88.907 M31.399,139.828
 c-1.701-7.423-4.521-24.583-1.055-46.811c11.846,0.602,22.648,1.252,33.947,2.045l6.336,0.432
 c-0.535,11.026-1.361,25.436-1.968,35.96c-0.229,4.023-0.426,7.407-0.551,9.697c-0.012,0.17-0.082,0.322-0.208,0.432
 c-0.12,0.109-0.285,0.164-0.454,0.153l-24.272-1.405v-0.016c-0.793-0.05-1.607-0.088-2.433-0.126l-0.12-0.006
 c-1.645-0.076-3.318-0.137-4.964-0.196C34.22,139.937,32.793,139.888,31.399,139.828 M11.233,482.646
 c0.547-9.72,7.39-63.872,7.462-64.43c0.043-0.437,4.564-43.815,7.472-62.171c1.952-12.306,5.948-28.126,8.162-36.457
 c1.487-5.621,2.203-11.42,2.121-17.237c-0.121-8.473-0.273-23.288,0.028-27.328c0.131-1.743,0.469-4.203,0.857-7.052
 c0.979-7.129,2.319-16.891,1.75-25.163c-0.246-3.602-0.864-8.702-1.574-14.617c-1.569-13.017-3.718-30.843-3.636-46.98
 c0.088-18.806-0.896-31.477-1.328-36.053c-0.082-0.891-0.246-1.782-0.481-2.646c-0.142-0.524-0.323-1.214-0.52-2.039
 c1.34,0.061,2.712,0.11,4.084,0.158c1.684,0.061,3.4,0.121,5.078,0.198l26.699,1.552h0.082c0.312,0,0.607-0.109,0.837-0.317
 c0.257-0.225,0.405-0.536,0.421-0.875c0.125-2.296,0.323-5.68,0.552-9.697c0.606-10.524,1.438-24.928,1.974-35.96l0.3,0.016
 l0.213-4.532l1.52-22.314c7.992,0.552,14.301,1.17,15.749,1.317c-1.196,14.29-2.864,33.587-4.849,55.099l-0.557,9.642l-9.009-6.357
 c-0.432-0.366-0.995-0.459-1.509-0.24c-0.547,0.223-0.913,0.754-0.962,1.372l-2.848,38.441l-12.541-0.973
 c-0.082-0.005-0.169,0.022-0.235,0.077c-0.065,0.059-0.103,0.136-0.109,0.223l-1.05,14.116h0.027
 c-0.89,11.266-2.197,31.525-2.978,43.634c-0.29,4.515-0.52,8.041-0.64,9.78c-0.06,0.94,0.607,1.76,1.492,1.831l19.002,1.558
 c-4.078,34.101-7.041,53.721-9.9,65.561c-11.644,48.222-27.786,177.742-28.754,185.565
 C26.708,487.861,19.187,485.713,11.233,482.646 M55.529,188.432c0.18-2.417,0.344-4.663,0.502-6.642l72.548,5.631
 c-0.136,1.973-0.29,4.22-0.459,6.647L55.529,188.432z M128.076,194.708c-1.121,16.192-2.788,39.933-3.242,45.668
 c-0.021,0.334-0.179,0.639-0.421,0.841c-0.213,0.181-0.486,0.269-0.759,0.246l-38.076-2.809v0.011l-32.242-2.641
 c-0.535-0.043-0.94-0.558-0.896-1.143c0.12-1.743,0.344-5.269,0.634-9.79c0.628-9.709,1.591-24.67,2.411-36.019L128.076,194.708z
  M56.053,181.145l1.001-13.475l72.569,5.635l-0.995,13.476L56.053,181.145z M120.221,163.515l-0.623,8.369l-49.632-3.853
 l2.843-38.447c0.027-0.377,0.246-0.695,0.568-0.831c0.29-0.121,0.602-0.072,0.869,0.159l9.359,6.603l0.618,0.438l34.767,24.528
 C119.849,161.209,120.308,162.345,120.221,163.515 M102.907,399.192c-0.097,0.399-9.653,40.093-11.113,56.913
 c-1.471,16.98-4.958,32.128-5.444,32.865c-0.383,0.274-8.118,2.942-21.922,3.341c-7.561,0.219-17.914-0.263-30.165-2.832
 c0.645-5.183,9.048-72.689,18.051-128.537c3.728,0.662,30.274,5.231,57.416,6.713C106.406,383.268,102.968,398.903,102.907,399.192
  M122.38,285.273c-0.766,6.538-5.527,43.984-6.549,51.922c-0.46,3.56-3.154,16.613-5.965,29.826
 c-27.169-1.475-53.763-6.062-57.454-6.713c3.598-22.265,7.283-42.629,10.6-56.377c2.712-11.213,5.505-29.367,9.25-60.128
 c2.887,0.531,30.17,5.446,55.973,7.965c-0.044,0.476-0.028,0.716,0.021,0.848C127.814,254.868,123.184,278.446,122.38,285.273
  M72.338,243.164c0.197-1.596,0.389-3.226,0.591-4.893l15.519,1.269l0.006-0.034l35.151,2.597c0.049,0,0.097,0.006,0.147,0.006
 c0.394,0,0.771-0.137,1.077-0.399c0.371-0.312,0.607-0.782,0.651-1.285c0.53-6.724,2.733-38.255,3.76-53.278l1.05-14.114
 c0.011-0.176-0.12-0.328-0.295-0.345l-9.758-0.755l0.624-8.369c0.103-1.377-0.444-2.711-1.477-3.592l-35.117-24.774l0.579-10.031
 c0.416-4.478,0.809-8.856,1.197-13.115c27.356-21.423,44.575-38.927,54.125-55.021c9.654,2.574,17.15,4.636,18.565,5.029
 l-1.088,38.146c-0.284,9.184-0.558,17.029-0.716,19.357c-0.454,6.735-3.077,28.646-5.997,44.247l-3.193,12.514
 c-0.328,1.278-1.416,5.274-2.913,10.806c-2.897,10.677-7.282,26.809-10.835,40.432c-3.963,15.202-5.325,21.178-5.68,23.572
 C102.41,248.603,75.006,243.656,72.338,243.164 M181.993,460.752c-8.708-0.328-15.809-0.836-22.888-1.782
 c-9.097-1.214-10.174-3.263-10.256-3.45c-0.005-1.492-0.142-37.101-1.246-52.539c-0.651-9.107-1.219-18.898-1.733-29.935
 c-0.372-7.971-0.744-16.46-0.864-25.005c-0.049-3.608,0-7.248,0.044-10.764c0.099-7.664,0.202-15.591-0.722-23.484
 c-1.776-15.143-4.871-30.302-7.861-44.963c-0.36-1.766-0.721-3.532-1.076-5.297c-0.941-4.631-2.46-9.583-6.571-11.283
 c-0.203-2.963,11.561-46.314,16.624-64.955c1.502-5.533,2.586-9.529,2.914-10.813l2.634-10.315
 c0.312,3.405,1.531,11.458,5.948,29.841l0.016,0.055c10.507,24.037,18.248,83.591,18.324,84.153
 c0.006,0.263,0.503,26.536,4.762,56.569C184.163,365.879,182.141,454.651,181.993,460.752 M226.443,364.599
 c-0.099,3.045-0.224,6.643-0.421,10.273l-0.011,0.223c-0.109,2.083-0.23,4.237-0.498,6.336c-0.049,0.333-0.093,0.672-0.158,1.012
 c-2.138,11.031-1.875,32.072-1.023,39.852c0.854,7.784-1.044,31.629-1.235,33.963c-1.383,0.657-11.622,5.177-27.098,4.876
 c-4.909-0.097-9.309-0.207-13.366-0.355c0.126-5.084,1.58-68.688-0.415-106.156c2,0.12,9.653,0.536,20.172,0.536
 c7.09,0,15.486-0.192,24.32-0.787C226.628,358.171,226.541,361.478,226.443,364.599 M227.509,272.317
 c-0.012,0.793-0.017,1.586-0.022,2.378l-0.011,4.936c-0.011,4.024-0.028,8.047-0.049,12.077c-0.022,4.734-0.05,9.467-0.082,14.202
 c-0.038,5.122-0.082,10.244-0.132,15.366c-0.055,5.183-0.114,10.365-0.185,15.553c-0.082,5.445-0.165,10.272-0.257,14.765
 c-0.017,0.728-0.028,1.438-0.044,2.132c-22.118,1.498-41.459,0.438-44.548,0.252c-0.371-6.839-0.863-12.775-1.503-17.286
 c-4.253-29.989-4.75-56.224-4.756-56.52c-0.044-0.343-2.651-20.384-6.872-41.901c3.937-0.082,27.404-0.77,50.512-5.374
 c0.296,0.924,0.585,1.843,0.869,2.761c1.602,5.199,2.931,9.999,4.062,14.673l0.153,0.623c1.115,4.625,2.274,9.408,2.712,14.131
 C227.579,267.49,227.541,269.945,227.509,272.317"
      />
      <path
        d="M467.023,238.572c-0.006-0.64-0.219-64.528-4.127-127.252c-3.783-60.669-12.89-77.451-13.591-78.659L447.83,14.32
 c-0.049-0.645-0.579-1.137-1.236-1.148c-76.5,1.498-150.064,0.935-165.579,0.706c-1.071,0-1.995,0.781-2.126,1.852l-2.093,17.138
 c-1.126,2.034-9.797,19.445-13.476,78.452c-0.606,9.779-1.164,20.183-1.65,30.908l-0.187,4.106
 c-0.41,9.511-0.781,19.461-1.099,29.574l-0.185,6.232c-0.93,32.428-1.001,56.192-1.006,56.426l-1.143,64.829
 c-0.038,2.17,0.028,4.368,0.203,6.532c0.486,6.085,0.759,19.812,0.978,30.843c0.164,8.102,0.301,15.094,0.482,17.335
 c0.513,6.281,1.574,47.259,1.585,47.669c0.016,0.564,1.344,56.088,1.853,64.933c0.514,8.932,1.377,17.083,1.924,18.177
 c0.41,0.82,14.12,2.651,27.573,3.389c13.432,0.743,31.926,0.798,43.755-3.149c0.258-0.087,0.448-0.306,0.498-0.574
 c0.929-5.243,5.116-42.005,5.811-62.73c0.677-20.412,0.311-71.427-0.235-77.965c-0.542-6.543,0.224-39.605,1.924-47.936
 c1.071-5.248,2.214-20.386,3.133-32.549c0.557-7.38,1.038-13.759,1.366-16.028c0.29-2.061,0.404-6.002,0.541-10.994
 c0.263-9.32,0.623-22.085,2.542-29.202c2.062-7.632,3.434-16.586,4.253-21.937c0.339-2.22,0.585-3.827,0.732-4.368
 c0.116-0.416,0.176-1.793,0.296-4.62c0.356-8.495,1.181-28.388,5.806-30.389h0.076c4.625,2.001,5.456,21.894,5.806,30.389
 c0.12,2.827,0.18,4.204,0.295,4.62c0.147,0.541,0.393,2.148,0.732,4.368c0.044,0.272,0.088,0.557,0.132,0.846
 c-0.012,0.247-0.017,0.394-0.022,0.411l0.087,0.005c0.836,5.423,2.149,13.612,4.056,20.675c1.919,7.117,2.28,19.882,2.542,29.202
 c0.143,4.992,0.252,8.933,0.547,10.994c0.322,2.274,0.81,8.791,1.372,16.339c0.919,12.382,2.066,27.788,3.138,33.03
 c1.712,8.391,2.116,41.519,1.58,47.937c-0.377,4.521,0.7,32.439,1.563,54.874c0.323,8.403,0.629,16.334,0.815,21.965
 c0.683,20.5,2.575,57.679,3.526,63.063c0.049,0.268,0.24,0.487,0.497,0.574c8.173,2.727,19.527,3.543,30.198,3.543
 c4.773,0,9.408-0.164,13.557-0.394c13.459-0.738,27.164-2.569,27.574-3.389c0.546-1.094,1.41-9.25,1.924-18.177
 c0.514-8.851,1.181-64.266,1.187-64.818c0.01-0.416,0.846-41.279,1.361-47.559c0.36-4.478,1.47-27.897,2.137-41.892
 c0.262-5.477,0.448-9.429,0.47-9.73l0.005-0.06L467.023,238.572z M466.373,237.101l-25.229,0.728
 c-0.372,0.015-0.727-0.121-1.001-0.378c-0.267-0.251-0.426-0.601-0.436-0.973c-0.236-8.276-0.957-33.51-1.372-52.365l27.07-0.64
 C466.175,210.774,466.339,231.542,466.373,237.101 M465.388,182.829l-27.07,0.64c-0.065-2.991-0.126-5.812-0.17-8.365l26.989-0.639
 C465.224,177.313,465.312,180.101,465.388,182.829 M465.115,173.82l-27.016,0.64l-0.399-16.811l26.825-0.639
 C464.749,162.772,464.946,168.397,465.115,173.82 M462.299,112.107c0.93,14.995,1.646,30.044,2.199,44.263l-10.092,0.241
 l-1.132-47.828c-0.016-0.476,0.23-0.901,0.646-1.137c0.415-0.235,0.902-0.223,1.306,0.033l7.046,4.472L462.299,112.107z
  M446.594,13.811c0.318,0.006,0.575,0.246,0.596,0.558l1.454,18.095c-0.267,0.021-0.591,0.054-0.924,0.082
 c-0.252,0.027-0.503,0.048-0.721,0.071l-0.962-18.794C446.222,13.823,446.409,13.817,446.594,13.811 M445.397,13.839l1.345,26.409
 c0.006,0.115-0.028,0.219-0.088,0.285c-0.027,0.021-0.06,0.049-0.104,0.049h-4.925c-0.087,0-0.186-0.11-0.197-0.28l-1.574-26.359
 C441.696,13.904,443.544,13.872,445.397,13.839 M439.214,13.954l1.121,18.827c-23.085,0.874-49.008,1.404-71.246,1.459l3.87-19.526
 C393.606,14.598,416.194,14.364,439.214,13.954 M351.491,14.802l4.029,19.324c-29.651-0.181-55.568-0.913-68.617-1.345l1.088-18.177
 C300.301,14.724,323.141,14.867,351.491,14.802 M287.346,14.594l-1.575,26.387c-0.011,0.169-0.109,0.284-0.191,0.284h-4.925
 c-0.05,0-0.082-0.027-0.105-0.054c-0.065-0.067-0.097-0.17-0.092-0.28l1.344-26.403C283.262,14.55,285.121,14.571,287.346,14.594
  M279.529,15.807c0.087-0.738,0.716-1.291,1.454-1.291h0.022c0.048,0,0.109,0.006,0.158,0.006l-0.924,18.122
 c-1.257-0.06-2.509-0.185-2.744-0.208L279.529,15.807z M262.129,146.361l0.179-4.101c0.067-1.464,0.137-2.913,0.203-4.362h0.241
 l34.778,0.766c0.132,0,0.257,0.055,0.351,0.158c0.103,0.109,0.163,0.258,0.158,0.416l-0.459,19.619l-36.102,3.849
 C261.68,157.152,261.893,151.685,262.129,146.361 M261.451,163.362l36.112-3.849l-0.142,5.976l-0.055,5.39l-8.62-0.213
 l-26.782-0.739l-0.104-0.021h-0.634C261.298,167.714,261.374,165.532,261.451,163.362 M362.704,149.307
 c-4.893,2.412-5.697,21.616-6.085,30.887c-0.093,2.296-0.169,4.11-0.268,4.477c-0.115,0.416-0.267,1.334-0.475,2.678
 c-0.432-8.964-1.613-34.368-1.246-37.735c0.24-2.236,2.005-3.724,3.039-4.412c1.689-1.12,3.712-1.662,5.035-1.378V149.307z
  M362.704,143.169c-1.498-0.257-3.598,0.305-5.391,1.503c-1.946,1.29-3.127,3.023-3.323,4.871
 c-0.443,4.127,1.317,39.458,1.393,40.956h0.006c-0.837,5.412-2.143,13.502-4.023,20.477c-1.942,7.195-2.302,20.003-2.565,29.356
 c-0.136,4.772-0.251,8.894-0.541,10.917c-0.328,2.296-0.808,8.681-1.366,16.072c-0.919,12.147-2.061,27.262-3.122,32.466
 c-1.711,8.37-2.481,41.557-1.934,48.123c0.545,6.527,0.913,57.492,0.229,77.889c-0.689,20.702-4.871,57.405-5.801,62.636
 c-0.005,0.038-0.032,0.066-0.065,0.076c-11.595,3.871-29.738,3.855-42.918,3.155c-14.902-0.787-26.634-2.624-27.661-3.127
 c-0.449-1.12-1.296-8.588-1.831-17.87c-0.509-8.834-1.837-64.348-1.849-64.911c-0.011-0.411-1.076-41.41-1.591-47.707
 c-0.175-2.22-0.316-9.207-0.475-17.291c-0.224-11.042-0.497-24.781-0.984-30.881c-0.17-2.143-0.24-4.319-0.202-6.473l1.148-64.834
 c0-0.055,0.005-1.487,0.022-4.067l2.23,0.038l32.838,1.066h0.055c0.388,0,0.749-0.147,1.033-0.415
 c0.312-0.296,0.491-0.706,0.497-1.159c0.055-3.154,0.148-7.807,0.257-13.333c0.29-14.405,0.678-34.14,0.853-49.156l-0.645-0.006
 c-0.17,15.012-0.563,34.741-0.847,49.15c-0.11,5.522-0.203,10.18-0.257,13.334c-0.005,0.278-0.115,0.525-0.301,0.705
 c-0.169,0.158-0.388,0.24-0.623,0.235l-31.209-1.006v-0.028l-1.656-0.027l-1.585-0.055v0.023l-0.635-0.011
 c0.071-8.49,0.29-27.727,0.978-51.698l0.187-6.233c0.055-1.797,0.114-3.585,0.175-5.373h0.59l0.065,0.011l26.869,0.749l8.664,0.213
 l0.618,0.006l0.06-6.035l0.618-26.245c0.006-0.334-0.115-0.646-0.339-0.881c-0.213-0.224-0.503-0.355-0.809-0.361l-34.472-0.765
 h-0.525c0.431-8.954,0.907-17.641,1.421-25.89c1.537-24.671,3.942-42.033,6.297-54.032l6.304,0.29l-0.755,23.594l-0.284,5.456
 l0.415,0.011c-0.601,11.895-0.907,21.56-1.158,29.328c-0.148,4.591-0.274,8.56-0.432,12.234c-0.016,0.377,0.12,0.738,0.382,1.017
 c0.296,0.317,0.732,0.508,1.192,0.519l35.189,1.055l33.166,1.384l1.191,0.054h0.105c0.557,0,1.103-0.208,1.509-0.574
 c0.387-0.361,0.612-0.831,0.633-1.334c0.509-11.589,1.006-24.124,1.602-40.644l0.509,0.022l0.185-5.412l1.176-23.228l11.513,0.541
 V143.169z M349.299,86.338l-0.092,2.721l-9.114-0.453l-25.879-1.394l-0.06,0.011l-28.71-0.875l-9.233-0.306l0.246-4.805l0.174-5.319
 L349.299,86.338z M276.648,75.261l0.568-17.613l73.33,3.423l-1.176,23.228l-0.049,1.382L276.648,75.261z M311.147,130.19
 l-1.766-0.076v0.021l-33.433-1c-0.295-0.01-0.564-0.125-0.743-0.317c-0.105-0.109-0.225-0.295-0.214-0.552
 c0.159-3.678,0.29-7.647,0.437-12.24c0.246-7.767,0.558-17.432,1.154-29.328l8.84,0.295l28.759,0.875l0.055-0.011l25.824,1.4
 l8.621,0.431c-0.601,16.515-1.092,29.056-1.601,40.645c-0.017,0.328-0.164,0.645-0.432,0.886c-0.301,0.278-0.727,0.42-1.148,0.404
 l-32.636-1.362v-0.021L311.147,130.19z M270.388,56.686c3.275-16.426,6.429-22.55,6.997-23.555c0.017-0.034,0.044-0.049,0.044-0.055
 c0.011,0,1.389,0.143,2.778,0.208l-0.389,7.615c-0.016,0.284,0.082,0.563,0.269,0.754c0.152,0.164,0.354,0.252,0.568,0.252h4.925
 c0.437,0,0.803-0.389,0.831-0.886l0.454-7.598c13.07,0.431,39.058,1.17,68.786,1.349l1.197,5.719
 c0.077,0.655,0.394,1.076,0.799,1.076h4.925l0.132,19.429L270.388,56.686z M357.679,40.931c-0.044-0.027-0.158-0.191-0.202-0.546
 l-5.33-25.583c6.456-0.017,13.196-0.044,20.155-0.083l-5.094,25.699c-0.038,0.322-0.142,0.486-0.154,0.509L357.679,40.931z
  M367.054,41.565c0.406,0,0.717-0.421,0.788-1.049l1.116-5.636c22.281-0.049,48.275-0.579,71.415-1.459l0.416,6.921
 c0.027,0.497,0.393,0.884,0.836,0.884h4.925c0.213,0,0.411-0.092,0.569-0.251c0.18-0.197,0.279-0.47,0.262-0.759l-0.349-6.959
 c0.229-0.017,0.491-0.044,0.754-0.072c0.372-0.033,0.749-0.071,1.028-0.092c0.573,1.038,3.744,7.232,7.025,23.713l-92.491,4.215
 l-0.136-19.456H367.054z M414.182,130.19l-1.705,0.05v0.021l-31.444,1.313l-1.192,0.049c-0.404,0.021-0.798-0.11-1.098-0.361
 c-0.296-0.246-0.465-0.574-0.482-0.929c-0.508-11.595-1-24.13-1.596-40.65l8.621-0.426l25.769-1.4l0.154,0.011l28.711-0.875
 l8.839-0.289c0.601,11.9,0.908,21.565,1.159,29.334c0.147,4.592,0.273,8.555,0.432,12.228c0.011,0.257-0.109,0.443-0.214,0.552
 c-0.18,0.192-0.448,0.307-0.737,0.317l-33.439,1v-0.021L414.182,130.19z M439.903,86.348l-28.667,0.875l-0.164-0.011l-25.824,1.394
 l-9.108,0.459l-0.098-2.727l72.651-10.42l0.191,5.325l0.252,4.799L439.903,86.348z M376.02,85.681l-0.05-1.388l-1.169-23.152
 l73.242-3.339l0.629,17.465L376.02,85.681z M369.865,184.671c-0.099-0.367-0.175-2.181-0.269-4.477
 c-0.387-9.343-1.196-28.787-6.193-30.947c-0.017-0.011-0.038-0.005-0.06-0.011v-5.4c1.318-0.318,3.384,0.223,5.106,1.366
 c1.033,0.688,2.799,2.176,3.039,4.412c0.355,3.307-0.771,27.879-1.219,37.244C370.094,185.781,369.963,185.037,369.865,184.671
  M467.11,316.406c-0.666,13.989-1.776,37.402-2.137,41.874c-0.513,6.298-1.356,47.183-1.361,47.598
 c-0.011,0.557-0.678,55.957-1.187,64.791c-0.535,9.282-1.382,16.75-1.831,17.87c-1.022,0.503-12.754,2.34-27.661,3.127
 c-13.179,0.7-31.318,0.716-42.919-3.155c-0.032-0.01-0.059-0.038-0.065-0.076c-0.945-5.357-2.837-42.486-3.515-62.97
 c-0.191-5.63-0.498-13.563-0.82-21.965c-0.863-22.418-1.936-50.315-1.564-54.797c0.537-6.44,0.131-39.693-1.59-48.117
 c-1.061-5.204-2.208-20.588-3.127-32.953c-0.563-7.555-1.05-14.082-1.377-16.384c-0.29-2.023-0.406-6.145-0.542-10.917
 c-0.262-9.353-0.623-22.161-2.564-29.356c-1.935-7.177-3.263-15.547-4.094-20.953c0.224-4.488,1.792-36.561,1.372-40.48
 c-0.197-1.848-1.377-3.581-3.324-4.871c-1.826-1.214-3.958-1.783-5.461-1.488V61.667l10.813-0.492l1.17,23.145l0.185,5.418
 l0.509-0.027c0.602,16.519,1.093,29.06,1.602,40.649c0.021,0.536,0.273,1.033,0.711,1.394c0.398,0.334,0.901,0.514,1.431,0.514
 h0.105l34.368-1.438l35.178-1.055c0.46-0.011,0.896-0.202,1.192-0.519c0.262-0.279,0.399-0.64,0.382-1.017
 c-0.158-3.674-0.284-7.632-0.432-12.224c-0.246-7.767-0.557-17.432-1.158-29.334l0.415-0.015l-0.279-5.45l-0.842-23.442l7.271-0.333
 c2.356,12.016,4.756,29.35,6.287,53.917c0.005,0.006,0.005,0.017,0.005,0.022l-6.686-4.243c-0.606-0.387-1.345-0.404-1.968-0.048
 c-0.628,0.349-0.989,0.995-0.972,1.711l1.131,47.822l-16.4,0.388c-0.175,0.005-0.317,0.153-0.312,0.334l0.415,17.455h0.034
 c0.339,18.673,1.285,51.949,1.569,61.701c0.016,0.542,0.24,1.05,0.64,1.422c0.377,0.355,0.874,0.551,1.393,0.551h0.061l25.217-0.732
 v0.837l1.203,68.075C467.559,306.965,467.379,310.72,467.11,316.406"
      />
    </svg>
  );
}
